import React from "react";

import {Button} from "./style";

export default ({status, ...props}) => (
    <Button {...props}>
        {!status ? 'Lees meer' : 'Lees minder'}
    </Button>
);
